var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"outlined":"","single-line":"","hide-details":"","prepend-inner-icon":"mdi-translate","items":_vm.items},model:{value:(_vm.currentLocale),callback:function ($$v) {_vm.currentLocale=$$v},expression:"currentLocale"}})}
var staticRenderFns = []

export { render, staticRenderFns }